import moment from 'moment';

moment.relativeTimeRounding(Math.floor);
moment.relativeTimeThreshold('s', 60);
moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 30);
moment.relativeTimeThreshold('M', 12);

const periodItems = [
    {
        text: 'Год',
        value: 'years',
        short: 'y',
    },
    {
        text: 'Месяц',
        value: 'months',
        short: 'M',
    },
    {
        text: 'День',
        value: 'days',
        short: 'd',
    },
    {
        text: 'Час',
        value: 'hours',
        short: 'h',
    },
];

export const parseDuration = (duration) => {
    const periods = duration.split(/[A-Z]/).filter(item => item !== '');
    let date = periods.find(item => item !== '0') || '';

    let dateIndex = periods.findIndex(item => item !== '0');
    if (dateIndex === -1) {
        return;
    }
    const periodItem = periodItems[dateIndex];
    let period = periodItem ? periodItem.value : '';
    moment.locale('ru');
    let result = moment.duration(date, period).humanize({[periodItem.short]: Number.MAX_VALUE});
    if (date === '1') {
        result = `1 ${result}`;
    }
    return result;
};
